import { render } from "./DemandeChart.vue?vue&type=template&id=64598307&ts=true"
import script from "./DemandeChart.vue?vue&type=script&lang=ts"
export * from "./DemandeChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__